import React, { useState } from 'react';
import {
  Box,
  Container,
  Typography,
  Tabs,
  Tab,
  Paper,
} from '@mui/material';
import {
  CloudUpload as UploadIcon,
  Folder as FolderIcon,
} from '@mui/icons-material';
import DocumentUpload from '../components/admin/DocumentUpload';
import DocumentList from '../components/admin/DocumentList';

const AdminDocumentManagement = () => {
  const [activeTab, setActiveTab] = useState(0);
  const [refreshTrigger, setRefreshTrigger] = useState(0);

  const handleTabChange = (event, newValue) => {
    setActiveTab(newValue);
  };

  const handleUploadSuccess = () => {
    // Trigger refresh of document list
    setRefreshTrigger(prev => prev + 1);
  };

  return (
    <Box sx={{ minHeight: '100vh', bgcolor: '#f5f5f5' }}>
      <Container maxWidth={false} disableGutters sx={{ width: '100%' }}>
        <Box sx={{ mb: 4, mt: 2 }}>
          <Typography gutterBottom sx={{ fontWeight: 600, color: 'text.primary', letterSpacing: 1, fontSize: '30px' }}>
            Document Management
          </Typography>
          <Typography variant="h5" color="text.secondary" gutterBottom sx={{ fontStyle: 'italic', fontWeight: 400, fontSize: '20px' }}>
            Upload, organize, and manage company documents
          </Typography>
        </Box>

        <Paper sx={{ mb: 3 }}>
          <Tabs
            value={activeTab}
            onChange={handleTabChange}
            sx={{
              borderBottom: 1,
              borderColor: 'divider',
              '& .MuiTab-root': {
                textTransform: 'none',
                fontWeight: 600,
                fontSize: '14px',
                minHeight: 64,
              },
            }}
          >
            <Tab
              icon={<UploadIcon />}
              label="Upload Documents"
              iconPosition="start"
              sx={{ flexDirection: 'row', gap: 1 }}
            />
            <Tab
              icon={<FolderIcon />}
              label="Document Library"
              iconPosition="start"
              sx={{ flexDirection: 'row', gap: 1 }}
            />
          </Tabs>
        </Paper>

        <Box sx={{ mt: 3 }}>
          {activeTab === 0 && (
            <DocumentUpload onUploadSuccess={handleUploadSuccess} />
          )}
          {activeTab === 1 && (
            <DocumentList refreshTrigger={refreshTrigger} />
          )}
        </Box>
      </Container>
    </Box>
  );
};

export default AdminDocumentManagement; 